import { motion } from "framer-motion";
import { MapPin, Phone, ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const MAP_SRC =
  "https://maps.google.com/maps?q=The%20Moon%20Cafe%2C%20Headstone%20Gardens%2C%20Harrow%20HA2%206PN&t=&z=16&ie=UTF8&iwloc=&output=embed";
const DIRECTIONS_URL =
  "https://www.google.com/maps/search/?api=1&query=The+Moon+Cafe+Headstone+Gardens+Harrow+HA2+6PN";

export default function FindUs() {
  return (
    <section
      id="visit"
      className="border-t border-line/50 py-24 md:py-32"
      data-testid="find-us-section"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-6 md:px-12 lg:grid-cols-2 lg:gap-16">
        <div className="flex flex-col justify-center">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="font-sans text-xs uppercase tracking-[0.35em] text-sage"
          >
            Find us
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
            className="mt-5 font-serif text-4xl font-medium leading-tight text-cream sm:text-5xl md:text-6xl"
          >
            Headstone Gardens, Harrow.
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
            className="mt-10 flex items-start gap-4"
          >
            <MapPin className="mt-1.5 h-5 w-5 shrink-0 text-sage" />
            <p className="font-serif text-2xl leading-snug text-cream md:text-3xl">
              The Moon Cafe
              <br />
              Headstone Gardens
              <br />
              Harrow, HA2 6PN
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.3 }}
            className="mt-10 flex items-start gap-4"
          >
            <Phone className="mt-2 h-5 w-5 shrink-0 text-sage" />
            <div>
              <p className="font-sans text-xs uppercase tracking-[0.3em] text-sage-dim">
                Call the cafe
              </p>
              <a
                href="tel:+442084275073"
                data-testid="phone-link"
                className="mt-1 inline-block font-serif text-2xl text-cream transition-colors duration-300 hover:text-sage md:text-3xl"
              >
                020 8427 5073
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.4 }}
            className="mt-12"
          >
            <a
              href={DIRECTIONS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="directions-link"
              className="group inline-flex items-center gap-3 rounded-full border border-line px-8 py-4 font-sans text-xs uppercase tracking-[0.25em] text-sage transition-colors duration-300 hover:border-sage/60 hover:text-cream"
            >
              Get directions
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1, ease: EASE, delay: 0.2 }}
          className="border border-line bg-ink2 p-2 md:p-3"
        >
          <iframe
            title="Map — The Moon Cafe, Headstone Gardens, Harrow HA2 6PN"
            src={MAP_SRC}
            data-testid="map-iframe"
            loading="lazy"
            className="map-dark h-[340px] w-full md:h-[460px] lg:h-full lg:min-h-[520px]"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </motion.div>
      </div>
    </section>
  );
}
